module.exports = __webpack_public_path__ + "img/logo_dzikri.6c19bee3.png";